export default function calculateNetRevenue(revenue = 0, cost = 0) {
  return revenue - cost;
}
